import { LIBELLES_STATUT_ANNONCE, type AnnonceResume, type StatutAnnonce } from '@rh/shared';

/**
 * Libellé d'une annonce dans une liste de rattachement : référence, intitulé
 * et, quand elle n'est plus ouverte, son état entre parenthèses — « close »
 * accepte encore une candidature partie avant la clôture, autant que le
 * responsable RH le voie avant de choisir.
 */
export function libelleAnnonceRattachement(annonce: AnnonceResume): string {
  const tete = annonce.reference ? `${annonce.reference} — ${annonce.intitule}` : annonce.intitule;
  const ouverte = annonce.statut === 'validee' || annonce.statut === 'publiee';
  if (ouverte) return tete;
  const etat = LIBELLES_STATUT_ANNONCE[annonce.statut as StatutAnnonce] ?? annonce.statut;
  return `${tete} (${etat.toLowerCase()})`;
}
